// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function ContentBox__Jsx3(props) {
  let __children = props.children;
  let __className = props.className;
  let __borderRadius = props.borderRadius;
  let __hasBorder = props.hasBorder;
  let __hasShadow = props.hasShadow;
  let __paddingFull = props.paddingFull;
  let paddingFull = __paddingFull !== undefined ? __paddingFull : false;
  let hasShadow = __hasShadow !== undefined ? __hasShadow : false;
  let hasBorder = __hasBorder !== undefined ? __hasBorder : false;
  let borderRadius = __borderRadius !== undefined ? __borderRadius : false;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  let base = TailwindMerge.twMerge([
    "bg-white",
    borderRadius ? "rounded-[5px]" : ""
  ]);
  let padding = TailwindMerge.twMerge([
    "p-[15px] sm:py-[5px] sm:px-5",
    paddingFull ? "sm:p-5" : ""
  ]);
  let extras = TailwindMerge.twMerge([
    hasShadow ? "shadow" : "",
    hasBorder ? "border border-zinc-300" : ""
  ]);
  let className$1 = TailwindMerge.twMerge([
    base,
    padding,
    extras,
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

let make = ContentBox__Jsx3;

exports.make = make;
/* tailwind-merge Not a pure module */
